module.exports = "/next-static/_next/static/images/complexInstallAndSetup-462893dd60256398b90d9530c28b35ed.png";